import React from 'react';
import { Container } from '../../globalStyles';
import {
    GallerySection,
    GalleryRow,
    ImageWrapper,
    GalleryImage
} from './Gallery.elements';

function Gallery({ data }) {
    console.log(data)
    return (
        <GallerySection>
            <Container style={{ marginTop: 10 }}>
                <GalleryRow>
                    {data.map((main, index) => (
                        <ImageWrapper key={index}>
                            <GalleryImage src={main.img} alt={`${main.img} ${index + 1}`} />
                        </ImageWrapper>
                    ))}
                </GalleryRow>
            </Container>
        </GallerySection>
    );
}

export default Gallery;
